import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=7ef1d5e8&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=7ef1d5e8&prod&lang=scss"
import style1 from "./Catalog.vue?vue&type=style&index=1&id=7ef1d5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef1d5e8",
  null
  
)

export default component.exports